import { useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import logo from '../img/newlogo.png';
import profileIcon from '../img/profile.png';
import './Header1.css';

function UmpireHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setIsProfileMenuOpen(false);
    navigate('/login');
  };

  const handleProfileClick = () => {
    navigate('/profile');
    setIsMenuOpen(false);
  };

  const handleNavClick = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const navItems = [
    { label: 'List of Games', path: '/listofgame' },
    { label: 'Completed Matches', path: '/completed-matches' },
  ];

  return (
    <header className="simple-header sticky-top bg-white">
      <div className="container-fluid d-flex justify-content-between align-items-center py-4 px-3">
        {/* Logo */}
        <div className="logo-container" onClick={() => handleNavClick('/listofgame')}>
          <img
            src={logo}
            alt="Logo"
            className="header-logo"
          />
        </div>

        {/* Hamburger Menu Button - Visible on small screens */}
        <button
          className="hamburger-btn d-lg-none"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Navigation Links - Desktop */}
        <nav className="nav-links d-none d-lg-flex align-items-center">
          {navItems.map((item) => (
            <button
              key={item.path}
              className={`nav-link-btn ${isActive(item.path) ? 'active-link' : ''}`}
              onClick={() => handleNavClick(item.path)}
            >
              {item.label}
            </button>
          ))}
        </nav>

        {/* Profile Icon - Desktop */}
        <div className="profile-container d-none d-lg-block">
          <div
            className="profile-wrapper"
            onMouseEnter={() => setIsProfileMenuOpen(true)}
            onMouseLeave={() => setIsProfileMenuOpen(false)}
          >
            <img
              src={profileIcon}
              alt="Profile"
              className="profile-img"
              onClick={handleProfileClick}
            />

            {isProfileMenuOpen && (
              <div className="profile-dropdown">
                <button
                  className="logout-btn"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        <nav className="mobile-nav">
          {navItems.map((item) => (
            <button
              key={item.path}
              className={`nav-link-btn ${isActive(item.path) ? 'active-link' : ''}`}
              onClick={() => handleNavClick(item.path)}
            >
              {item.label}
            </button>
          ))}
          
          {/* Profile in Mobile Menu */}
          <div className="mobile-profile" onClick={handleProfileClick}>
            <img
              src={profileIcon}
              alt="Profile"
              className="profile-img-mobile"
            />
            <span className="profile-text">Profile</span>
          </div>

          {/* Logout Button in Mobile Menu */}
          <button
            className="mobile-logout-btn"
            onClick={handleLogout}
          >
            Logout
          </button>
        </nav>
      </div>
    </header>
  );
}

export default UmpireHeader;